export const LANG = 'LANG'